import React from 'react';
import { useSearchConfig } from '../hooks/useSearchConfig';

type ActiveSearchTermProps = Readonly<{
  searchTerm: string;
}>;

export default function ActiveSearchTerm({ searchTerm }: ActiveSearchTermProps) {
  const { labels } = useSearchConfig();
  return (
    <div className="active-search-term">
      <p className="active-search-term__label">
        <svg className="active-search-term__icon" aria-hidden="true">
          <use href="/dist/assets/icons/sprite.svg#search-portal"></use>
        </svg>
        {labels.searchResultForLabel}
      </p>
      <p className="active-search-term__value">{searchTerm}</p>
    </div>
  );
}
